/**
 * Utilidades para manejo de CSV y errores
 */

/**
 * Genera contenido CSV a partir de los journals
 * @param {Array} journals - Array de journals
 * @returns {string} - Contenido CSV como string
 */
// Escapes a field for CSV output
function escapeCsvField(field) {
  if (field === null || field === undefined) return '';
  const str = String(field);
  // If field contains quotes, commas, or newlines, escape it
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export const generateCsvContent = (journals) => {
  const headers = ['ID', 'Journal ID', 'Batch ID', 'Status', 'Razón', 'Creado', 'Actualizado'];
  
  const csvRows = [
    headers.map(escapeCsvField).join(','), // Header row
    ...journals.map(journal => [
      escapeCsvField(journal.id),
      escapeCsvField(journal.journal_id),
      escapeCsvField(journal.batch_id),
      escapeCsvField(journal.status),
      escapeCsvField(journal.reason || '-'),
      escapeCsvField(new Date(journal.created_at).toLocaleString()),
      escapeCsvField(new Date(journal.updated_at).toLocaleString())
    ].join(','))
  ];
  
  return csvRows.join('\n');
};

/**
 * Descarga un archivo CSV
 * @param {string} content - Contenido del CSV
 * @param {string} filename - Nombre del archivo
 */
export const downloadCsv = (content, filename) => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  link.href = url;
  link.download = filename;
  
  // Agregar al DOM, hacer click y remover
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Limpiar la URL del objeto
  window.URL.revokeObjectURL(url);
};

/**
 * Genera nombre de archivo CSV con timestamp
 * @param {string} country - País (ej: 'CL', 'CO')
 * @returns {string} - Nombre del archivo
 */
export const generateCsvFilename = (country) => {
  const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
  return `journals_${country.toLowerCase()}_${timestamp}.csv`;
};

/**
 * Maneja errores de manera consistente
 * @param {Error} error - Error capturado
 * @param {string} defaultMessage - Mensaje por defecto si no hay error.message
 * @returns {string} - Mensaje de error formateado
 */
export const handleError = (error, defaultMessage = 'Ha ocurrido un error') => {
  console.error(error);
  return error.message || defaultMessage;
};

/**
 * Valida si un objeto de respuesta tiene la estructura esperada
 * @param {object} data - Datos de respuesta
 * @returns {boolean} - Si la estructura es válida
 */
export const validateResponseData = (data) => {
  return (
    data && 
    typeof data === 'object' && 
    Array.isArray(data.journals) &&
    typeof data.total === 'number' &&
    typeof data.country === 'string'
  );
};
